import { render } from "./Grafic.vue?vue&type=template&id=3a8d37cf"
import script from "./Grafic.vue?vue&type=script&lang=js"
export * from "./Grafic.vue?vue&type=script&lang=js"

import "./Grafic.vue?vue&type=style&index=0&id=3a8d37cf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__